import "@/App.css";
import { Toaster } from "sonner";
import { LenisProvider } from "@/hooks/useLenis";
import { Navbar } from "@/components/cafe/Navbar";
import { Hero } from "@/components/cafe/Hero";
import { Marquee } from "@/components/cafe/Marquee";
import { About } from "@/components/cafe/About";
import { MenuSection } from "@/components/cafe/MenuSection";
import { Gallery } from "@/components/cafe/Gallery";
import { Hours } from "@/components/cafe/Hours";
import { Contact } from "@/components/cafe/Contact";
import { Footer } from "@/components/cafe/Footer";

export default function App() {
  return (
    <LenisProvider>
      <div className="min-h-screen bg-[#FAF7F2] font-sans text-[#1B3B2B] antialiased">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <MenuSection />
          <Gallery />
          <Hours />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#12281D",
              color: "#F5F0E6",
              border: "1px solid rgba(245,240,230,0.15)",
            },
          }}
        />
      </div>
    </LenisProvider>
  );
}
